import axiosInstance from "../utils/axiosInstance"
import { API_ENDPOINTS } from "../constants/config"

const unwrap = (response) => response?.data?.data ?? response?.data ?? {}

const normalizeAssignments = (payload) => {
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.assignments)) return payload.assignments
  if (Array.isArray(payload?.shiftAssignments)) return payload.shiftAssignments
  if (Array.isArray(payload?.data)) return payload.data
  return []
}

const normalizeShifts = (payload) => {
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.shifts)) return payload.shifts
  return []
}

const normalizeUsers = (teachersPayload, staffPayload) => {
  const teachers = Array.isArray(teachersPayload?.teachers) ? teachersPayload.teachers : []
  const staff = Array.isArray(staffPayload?.staff) ? staffPayload.staff : []

  return [
    ...teachers.map((user) => ({ ...user, role: "teacher" })),
    ...staff.map((user) => ({ ...user, role: "staff" })),
  ]
}

export const shiftAssignmentService = {
  async getUsers() {
    const [teachersResponse, staffResponse] = await Promise.all([
      axiosInstance.get(API_ENDPOINTS.usersTeachers, { params: { status: "all" } }),
      axiosInstance.get(API_ENDPOINTS.usersStaff, { params: { status: "all" } }),
    ])

    return normalizeUsers(unwrap(teachersResponse), unwrap(staffResponse))
  },

  async getShifts() {
    const response = await axiosInstance.get(API_ENDPOINTS.workShifts)
    return normalizeShifts(unwrap(response))
  },

  async getAssignments({ page = 1, limit = 25 } = {}) {
    const response = await axiosInstance.get(API_ENDPOINTS.shiftAssignments, {
      params: {
        paginate: true,
        page,
        limit,
        active: "true",
      },
    })
    const payload = unwrap(response)
    return {
      items: normalizeAssignments(payload),
      total: Number(response?.data?.total ?? payload?.total ?? payload?.count ?? 0),
    }
  },

  async createAssignment(payload) {
    const response = await axiosInstance.post(API_ENDPOINTS.shiftAssignments, payload)
    return unwrap(response)
  },

  async deleteAssignment(id) {
    const response = await axiosInstance.delete(API_ENDPOINTS.shiftAssignment(id))
    return unwrap(response)
  },
}

export default shiftAssignmentService
